import { getAssetPersist } from "src/api/asset-persist/stores/useAssetPersist";
import { getClientId } from "src/helpers/globalHelpers";

const shouldBeThumbnail = ({
	numPhotos,
	i,
	ownerId,
	gatheringId,
}: {
	numPhotos: number | null | undefined;
	i: number;
	ownerId: string | null | undefined;
	gatheringId: string;
}): boolean => {
	if ((numPhotos ?? 0) > 0) return false;
	if (i !== 0) return false;
	if (!ownerId) return false;
	if (getClientId() !== ownerId) return false;
	if (
		Object.values(getAssetPersist().uploadAssetsStore).some(
			(photo) => photo.gatheringId === gatheringId,
		)
	) {
		return false;
	}
	return true;
};
export default shouldBeThumbnail;
